import { Card, CardBody, Col } from "reactstrap";
import DefaultRangeSliderForm from "./DefaultRangeSliderForm";
import { BasicSliderData } from "../../../../data/bonusUi/RangSlider";
import { DefaultRangeTitle } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const DefaultRangeSlider = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={DefaultRangeTitle} span={BasicSliderData} />
        <CardBody>
          <DefaultRangeSliderForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultRangeSlider;
